import { Alert } from '@interstate/components/Alert';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Separator } from '../../ComplianceForm.style';

interface SuccessErrorAlertProps {
    title: string;
    description: string;
    testId: string;
    separatorTestId?: string;
    type: 'success' | 'error';
    hideSeparator?: boolean;
}

export const SuccessErrorAlert = ({ title, description, testId, separatorTestId, type, hideSeparator }: SuccessErrorAlertProps) => {
    const theme = useInterstateTheme();

    return (
        <>
            <Alert data-testid={testId} title={title} type={type} disableSuccessFade>
                <span>{description}</span>
            </Alert>
            <Separator
                isVisible={!hideSeparator}
                theme={theme}
                className="card_separator"
                data-testid={separatorTestId}
                aria-hidden="true"
            />
        </>
    );
};
